import React from "react";
import {
  Route,
  Redirect,
  RouteProps,
  RouteComponentProps,
} from "react-router-dom";
import { IonProgressBar } from "@ionic/react";
import { useAuth } from "@/hooks/useAuth";

interface OrganisationRouteProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps>;
}

const OrganisationRoute: React.FC<OrganisationRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const { isAuthenticated, currentOrganisation, isLoading } = useAuth();

  return (
    <>
      {isLoading && (
        <IonProgressBar
          type="indeterminate"
          style={{
            position: "fixed",
            top: "var(--ion-safe-area-top, 0)",
            zIndex: 9999,
          }}
        />
      )}
      {!isLoading && (
        <Route
          {...rest}
          render={(props) => {
            // Not authenticated -> redirect to welcome
            if (!isAuthenticated) {
              return (
                <Redirect
                  to={{
                    pathname: "/auth/welcome",
                    state: { from: props.location },
                  }}
                />
              );
            }

            // Authenticated but no organisation selected -> redirect to profile
            if (!currentOrganisation && !isLoading) {
              return (
                <Redirect
                  to={{
                    pathname: "/tabs/profile",
                    state: { from: props.location },
                  }}
                />
              );
            }

            // Authenticated and organisation selected -> render component
            return <Component {...props} />;
          }}
        />
      )}
    </>
  );
};

export default OrganisationRoute;
